import TB from '@tiger/bridge';
import { useCallback } from 'react';
import { usePowerNavigate } from 'components/PowerNavigate';
import UI from 'stores/ui';

/**
 * @description 跳向个人中心的通用hook，在APP内默认会关闭当前页面
 */
function useGotoProfile(quitInApp: boolean = true) {
    const navigate = usePowerNavigate();
    const gotoProfile = useCallback(() => {
        if (UI.isTiger && quitInApp) {
            TB.quit();
        } else {
            navigate('/profile');
        }
    }, [navigate, quitInApp]);

    return gotoProfile;
}

export default useGotoProfile;
